var map = {
	"./sampang/Footer.js": [
		1572,
		229,
		591,
		572
	],
	"./sampanganimation/Footer.js": [
		3298,
		229,
		591,
		650,
		410,
		298
	],
	"./sampanganimation/components/Footer/Footer.js": [
		4899,
		650,
		623
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7240;
module.exports = webpackAsyncContext;